import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { ContactModalProvider } from './ContactModal';

/*
 * Public page shell: Navbar (correct menu variant) + main content + Footer,
 * wrapped in the ContactModalProvider so any CTA can open the contact popup.
 *   navVariant: 'main' (Home) | 'page' (detail pages)
 */
export default function SiteLayout({ navVariant = 'main', children }) {
  return (
    <ContactModalProvider>
      <Navbar variant={navVariant} />
      <main style={{ flex: 1 }}>{children}</main>
      <Footer />
    </ContactModalProvider>
  );
}
